import styled from 'styled-components'
import media from '../../../styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 0;
  color: #007bff;
`

export const Title = styled.h2`
  text-align: center;
  line-height: 1.1;
`

export const SubTitle = styled.h3`
  text-align: center;
  font-size: 1.25rem;
  line-height: 1.1;
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${media.md`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
  `}
`
export const Code = styled.div``

export const CreateAccountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${media.md`
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  `}
`

export const Pre = styled.pre`
  position: relative;
  display: flex;
  font-size: 10px;
  color: black;
  background-color: #f8f9fa;
  margin-top: 0;
  overflow: auto;
  padding: 20px 0;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  word-break: normal;

  ${media.md`
    font-size: 16px;
    padding: 20px;
  `}
`

export const CodeCustom = styled.code``

export const Details = styled.p`
  color: #7a7878;
  font-size: 1rem;
  text-align: center;
  ${media.md`
    font-size: 16px;
    text-align: start;
  `}
`
export const Button = styled.a`
  border: 1px solid #008de6;
  border-radius: 3px;
  background-color: #007bff;
  color: white;
  margin-bottom: 10px;
  padding: 0.5rem 1rem;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  ${media.md` 
    padding: 0.5rem 1.75rem;
  `}
`

export const ButtonPrimary = styled.a`
  border: 1px solid #008de6;
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 0.5rem 1rem;
  text-decoration: none;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #6c757d;
  border-color: #6c757d;
  ${media.md` 
    padding: 0.5rem 1.75rem;
  `}
`

export const ButtonSecondary = styled.a`
  border: 1px solid #008de6;
  border-radius: 3px;
  color: white;
  margin-bottom: 10px;
  padding: 0.5rem 1rem;
  text-decoration: none;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #007bff;
  border-color: #007bff;
  ${media.md` 
    padding: 0.5rem 1.75rem;
  `}
`
